/*
 * quickPanel constants
 */

import { AppNamespace, QuickPanelAppName } from 'app/store/stateConstants';

const QuickPanelNamespace = `${AppNamespace}/${QuickPanelAppName}`;

export const TOGGLE_QUICK_PANEL = `${QuickPanelNamespace}/TOGGLE_QUICK_PANEL`;
